// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sources-popover{max-width:415px}.sources-popover .popover-body{padding:15px!important}.sources-popover h3{font-size:14px;font-weight:500;color:#2680eb}.sources-popover a{border-bottom:1px dashed #cfd8dc;padding:10px 0;color:#141c20}.sources-popover a:hover{cursor:pointer}.sources-popover a:last-of-type{border-bottom:none;padding:9px 0 0}.sources-popover a p{line-height:1!important}.sources-popover a:hover .sb-icon .mask{background-color:#141c20!important}", ""]);
// Exports
module.exports = exports;
